export default __webpack_public_path__ + "static/media/lato-black.f1f324db.ttf";